export default __webpack_public_path__ + "static/media/volleyball.2d2cd61e.png";